import { ViewDynamicInterface } from 'common/module/view/dynamic.interface';
import { TooltipServiceInterface } from 'common/service/tooltip/service.interface';
import { PropertyCallTooltipViewStore } from 'desktop/module/property/call-tooltip/view-store';
import { PropertyCallTooltipViewStoreEvent } from 'desktop/module/property/call-tooltip/view-store.event';

import { CallToolTipViewOptionsInterface } from './view-options.interface';

export class PropertyCallTooltipView {
  /**
   * Constructor
   */
  constructor(
    private tooltipService: TooltipServiceInterface,
    private tooltipCall: ViewDynamicInterface<PropertyCallTooltipViewStore>
  ) {}

  /**
   * Initialize the tooltip
   */
  public initialize(options: CallToolTipViewOptionsInterface): void {
    // Phone contact option is not available on property expired
    if (!options.model.meta.contact_options.details.phone) {
      return;
    }

    this.tooltipService.initialize({
      element: options.element,
    });

    this.tooltipCall.getViewStore().updateModel(options.model);

    this.tooltipCall.initialize({
      element: this.tooltipService.getContentElement(),
    });

    this.tooltipCall
      .getViewStore()
      .getEventEmitter()
      .addListener(PropertyCallTooltipViewStoreEvent.clickClose, this.onClickCloseTooltip);
  }

  /**
   * Destroy the tooltip
   */
  public destroy(): void {
    this.tooltipCall
      .getViewStore()
      .getEventEmitter()
      .removeListener(PropertyCallTooltipViewStoreEvent.clickClose, this.onClickCloseTooltip);
  }

  /**
   * Open the tooltip
   */
  public open(): void {
    this.tooltipCall.render();
    this.tooltipService.open();
  }

  /**
   * Close the tooltip
   */
  public close(): void {
    this.destroy();
    this.tooltipService.reset();
  }

  /**
   * Clicked close tooltip
   */
  private onClickCloseTooltip = () => {
    this.close();
  };
}
